"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var splide_1 = __importDefault(require("@splidejs/splide"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var SplideSlider = /** @class */ (function (_super) {
    __extends(SplideSlider, _super);
    function SplideSlider() {
        var _this = _super.call(this) || this;
        var main = document.querySelector('main');
        _this.setElement(main);
        _this.initSliders();
        return _this;
    }
    SplideSlider.prototype.initSliders = function () {
        var _a, _b, _c, _d;
        // Slider - Boxes
        (_a = this.getChildElements("[".concat(constants_1.DATA_SLIDER_BOXES, "]"))) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            var splide = new splide_1.default(element, {
                type: 'loop',
                perPage: 1,
                perMove: 1,
                gap: 10,
                autoplay: false,
                focus: 'center',
                padding: '22px',
                rewind: true,
                speed: 1000,
                arrows: true,
                pagination: false,
                lazyLoad: 'nearby',
                mediaQuery: 'min',
                breakpoints: {
                    1024: {
                        perPage: 4,
                        perMove: 4
                    },
                    768: {
                        perPage: 3,
                        perMove: 3,
                        gap: 20,
                        padding: '0'
                    },
                    480: {
                        perPage: 2,
                        perMove: 2,
                        focus: 0,
                    }
                }
            });
            // "Show all" button
            var showAllBtn = element.nextElementSibling.querySelector("[".concat(constants_1.DATA_SLIDER_ALL, "]"));
            showAllBtn.setAttribute('active', 'false');
            showAllBtn.addEventListener('click', function () {
                window.scrollTo({
                    top: element.offsetTop - 90,
                    behavior: 'smooth'
                });
                setTimeout(function () {
                    if (showAllBtn.getAttribute('active') == 'true') {
                        element.classList.remove('slider--no-slider');
                        showAllBtn.classList.remove(constantsClasses_1.CLASS_HIDDEN);
                        showAllBtn.setAttribute('active', 'false');
                        splide.mount();
                    }
                    else {
                        splide.destroy();
                        showAllBtn.setAttribute('active', 'true');
                        showAllBtn.classList.add(constantsClasses_1.CLASS_HIDDEN);
                        element.classList.add('slider--no-slider');
                    }
                }, 300);
            });
            splide.mount();
        });
        // Slider - Teaser Boxes mask element
        (_b = this.getChildElements("[".concat(constants_1.DATA_SLIDER_TEASER, "]"))) === null || _b === void 0 ? void 0 : _b.forEach(function (element) {
            var splide = new splide_1.default(element, {
                type: 'loop',
                perPage: 1,
                autoplay: true,
                resetProgress: false,
                rewind: true,
                speed: 800,
                arrows: false,
                pagination: false,
                lazyLoad: 'nearby',
                mediaQuery: 'min',
                breakpoints: {
                    1024: {
                        arrows: true
                    },
                }
            });
            var bars = splide.root.querySelectorAll("[".concat(constants_1.DATA_SLIDER_PROGRESS, "]"));
            splide.on('autoplay:playing', function (rate) {
                bars.forEach(function (bar) {
                    bar.style.width = String(100 * rate) + '%';
                });
            });
            splide.mount();
        });
        // Slider - Site content (e.g. news or products)
        (_c = this.getChildElements("[".concat(constants_1.DATA_SLIDER_CONTENT, "]"))) === null || _c === void 0 ? void 0 : _c.forEach(function (element) {
            var splide = new splide_1.default(element, {
                type: 'loop',
                perPage: 1,
                autoplay: true,
                resetProgress: false,
                rewind: true,
                speed: 800,
                arrows: true,
                pagination: false,
                lazyLoad: 'nearby',
                mediaQuery: 'min'
            });
            var bars = splide.root.querySelectorAll("[".concat(constants_1.DATA_SLIDER_PROGRESS, "]"));
            splide.on('autoplay:playing', function (rate) {
                bars.forEach(function (bar) {
                    bar.style.width = String(100 * rate) + '%';
                });
            });
            splide.mount();
        });
        // Slider - References list items
        (_d = this.getChildElements("[".concat(constants_1.DATA_SLIDER_REFERENCES, "]"))) === null || _d === void 0 ? void 0 : _d.forEach(function (element) {
            var splide = new splide_1.default(element, {
                type: 'loop',
                perPage: 1,
                autoplay: true,
                rewind: true,
                speed: 1000,
                arrows: false,
                pagination: false,
                lazyLoad: 'nearby',
                mediaQuery: 'min',
                breakpoints: {
                    1440: {
                        arrows: true
                    },
                }
            });
            splide.mount();
        });
    };
    return SplideSlider;
}(AbstractComponent_1.default));
exports.default = SplideSlider;
